<template>
    <div class="container doubts-container">
        <div class="title-container">
            <h3 class="title">Dúvidas</h3>
            <p class="subtitle">Gerencie as dúvidas e perguntas frequentes do sistema.</p>
        </div>

        <div class="search-row">
            <div class="form-group search-form-group" style="flex: 8;">
                <div class="form-input search-form-input">
                    <input
                        type="text" 
                        class="form-control search-form-control"
                        placeholder="Pesquisar dúvida..."
                        v-model="searchText"
                    />
                    <fa icon="fa-search" class="input-icon search-input-icon" @click="buscarDoubt" />
                </div>
            </div>

            <div class="form-group filter-form-group" style="flex: 2; display: flex; align-items: center;">
                <label style="margin-right: 0.5rem;">Filtrar por:</label>
                <select v-model="statusFilter" class="form-control filter-form-control" @change="filtrarDoubts">
                    <option value="todos">Todos</option>
                    <option value="ativo">Ativo</option>
                    <option value="inativo">Inativo</option>
                </select>
            </div>
        </div>

        <Loader v-if="!hasReady" />
        <div v-else class="table-responsive doubts-table-responsive">
            <table class="table doubts-table">
                <thead>
                    <tr>
                        <th style="width: 50%; text-align: left;">Título</th>
                        <th style="width: 20%; text-align: left;">Aluno(a)</th>
                        <th style="width: 15%;">Data de Abertura</th>
                        <th style="width: 10%;">Status</th>
                        <th style="width: 5%;"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="doubt in paginatedDoubts" :key="doubt.id">
                        <td style="width: 50%; text-align: left;">{{doubt.title}}</td>
                        <td style="width: 20%; text-align: left;">{{doubt.nameUser.charAt(0).toUpperCase() + doubt.nameUser.slice(1)}}</td>
                        <td style="width: 15%;">{{ new Date(doubt.dateInsert).toLocaleDateString() }}</td>
                        <td style="width: 10%;">
                            <span :class="doubt.status && doubt.status == 1 ? 'badge-active' : 'badge-inactive'">
                                {{doubt.status && doubt.status == 1 ? 'Aberto' : 'Fechado'}}
                            </span>
                        </td>
                        <td style="width: 5%;">
                            <button class="btn-edit doubt-btn-edit" @click="editDoubt(doubt.id)">
                                <fa icon="fa-file-alt"/>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="pagination doubts-pagination">
            <button 
                :disabled="currentPage === 1" 
                @click="currentPage--"
                class="page-btn doubts-page-btn"
            >
                Anterior
            </button>
            <span class="page-info doubts-page-info">Página {{currentPage}} de {{totalPages}}</span>
            <button 
                :disabled="currentPage === totalPages" 
                @click="currentPage++"
                class="page-btn doubts-page-btn"
            >
                Próxima
            </button>
        </div>

        <Loader :hasReady="hasReady" />
    </div>
</template>

<script>

import Loader from '@/components/Loader/loader.vue';
import ApiInquiry from '@/utils/inquiry';

import { mapState } from 'vuex';


export default {
    data() {
        return {
            label: this.labels,
            doubtsFiltered: [],
            searchTerm: '',
            currentPage: 1,
            itemsPerPage: 5,
            alertOpenDoubt:false,
            removedDoubtName:'',
            afterWidth:40,
            doubtsData:[],
            openModalCreateDoubt:false,
            openModalEditDoubt:false,
            id:'',
            message:'',
            title:'',
            hasReady: false,
            status: '1',
            isMobileIcon: false,
            statusFilter: 'todos',
            searchText: '',
        };
    },
    mounted() {
        this.checkScreenSize();
        window.addEventListener('resize', this.checkScreenSize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkScreenSize);
    },
    computed:{
        ...mapState(["token","numberIntensTable"]),

        paginatedDoubts() {
            const startIndex = (this.currentPage - 1) * this.numberIntensTable;
            const endIndex = startIndex + this.numberIntensTable;
            return this.filteredDoubts.slice(startIndex, endIndex);
        },
        totalPages() {
            return Math.ceil(this.filteredDoubts.length / this.numberIntensTable);
        },
        filteredDoubts() {
            let filtered = this.doubtsData;

            if (this.searchText && this.searchText.trim() !== '') {
                filtered = filtered.filter((doubt) =>
                    doubt.title.toLowerCase().includes(this.searchText.toLowerCase())
                );
            }
            if (this.statusFilter !== 'todos') {
                filtered = filtered.filter((doubt) =>
                    doubt.status && (doubt.status === (this.statusFilter === 'ativo' ? 1 : 0))
                );
            }

            return filtered;
        }
    },
    methods: {
        filtrarDoubts() {
            this.currentPage = 1;
        },
        previousPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
            }
        },
        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++;
            }
        },
        removeDoubt(id, name){
            this.removedDoubtName = name;
            this.alertOpenDoubt = !this.alertOpenDoubt;
            setTimeout(() => {
                this.alertOpenDoubt = !this.alertOpenDoubt;
                this.removedDoubtName = '';
            }, 4000);
        },
        editDoubt(id, title, description, status){
            this.openModalEditDoubt = !this.openModalEditDoubt;
            this.id = id;
            this.title = title;
            this.message = description;
            this.status = status;
        },
        createDoubt(){
            this.openModalCreateDoubt = !this.openModalCreateDoubt;
        },
        updateValueCreate(newValue){
            this.openModalCreateDoubt = newValue;
            this.getDataDoubt();
        },
        updateValueEdit(newValue){
            this.getDataDoubt();

            this.openModalEditDoubt = newValue;
        },
        checkScreenSize() {
            this.isMobileIcon = window.innerWidth <= 600;
        },
        async getListInquiry() {
            try {
                const response = await ApiInquiry.getDataInquiry(this.token);
                this.doubtsData = response.map(doubt => {
                    const { id, ...rest } = doubt;
                    return rest;
                });
                this.hasReady = true;
                this.doubtsFiltered = this.doubtsData;
            } catch (error) {
                console.error('Erro ao carregar as dúvidas', error);
            }
        }
    },
    components: {
        Loader
    },
    created(){
        this.getListInquiry();
    },
    
};
</script>

<style scoped>
.container {
    max-width: 100%;
    background-color: #ffffff;
    padding: 1.5rem;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}
.search-form-input{
    position: relative;
    width: 100%;
}
.title-container {
      position: relative;
    margin-bottom: 10px;
    padding-bottom: 0;
    border-bottom: 1px solid #f0f0f0;
    text-align: left;
}

.title-container .title {
    font-size: 1.5rem;
    font-weight: 700;
    color: #000000;
    margin-bottom: 0.5rem;
}

.title-container .subtitle {
    color: #6b7280;
    font-size: 0.875rem;
    line-height: 1.4;
    margin-bottom: 1rem;
}

.search-row {
    display: flex;
    gap: 0.75rem;
    margin-bottom: 1.5rem;
}

.search-row .form-group {
    flex: 1;
}

.btn-weflix.absolute {
    position: absolute;
    top: 0;
    right: 0;
    background-color: #2f2e8b;
    color: white;
    padding: 0.5rem 1rem;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: 600;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(47, 46, 139, 0.2);
}

.btn-weflix.absolute:hover {
    background-color: #23225f;
    transform: translateY(-2px);
}

.doubts-table-responsive {
    background-color: #ffffff;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 1rem;
}

.doubts-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
}

.doubts-table th {
    background-color: #f8fafc;
    padding: 0.75rem;
    font-weight: 600;
    color: #4a5568;
    text-align: left;
    border-bottom: 2px solid #e2e8f0;
}

.doubts-table td {
    padding: 0.75rem;
    vertical-align: middle;
    border-bottom: 1px solid #f0f0f0;
    color: #4a5568;
}

.doubts-table tr:hover {
    background-color: #f8fafc;
}

.badge-active, .badge-inactive {
    padding: 0.25rem 0.75rem;
    border-radius: 5px;
    font-size: 0.75rem;
    font-weight: 500;
    display: inline-block;
    text-align: center;
    transition: all 0.2s ease;
    width: 70%;
}

.badge-active {
    background-color: #7bcc8180;
    color: #4b614e;
}

.badge-inactive {
  background-color: #d7d7ee80;
    color: #2f2e8b;
    }

.doubt-btn-edit {
    padding: 0.4rem;
    margin: 0 0.25rem;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
   color: #2f2e8b;
}


.search-form-input {
    position: relative;
}

.search-form-control {
    width: 100%;
    padding: 0.5rem 0.75rem;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 0.875rem;
    transition: all 0.2s ease;
}

.search-form-control:focus {
    outline: none;
    border-color: #2f2e8b;
    box-shadow: 0 0 0 3px rgba(47, 46, 139, 0.1);
}

.search-input-icon {
    position: absolute;
    right: 0.75rem;
    top: 45%;
    transform: translateY(-50%);
    color: #9ca3af;
    cursor: pointer;
}

.doubts-pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    margin-top: 1rem;
}

.doubts-page-btn {
    padding: 0.5rem 1rem;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    background: white;
    color: #4a5568;
    cursor: pointer;
    transition: all 0.2s;
}

.doubts-page-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.doubts-page-btn:not(:disabled):hover {
    background: #f8fafc;
    border-color: #cbd5e0;
}

.doubts-page-info {
    color: #4a5568;
    font-size: 0.875rem;
}

@media (max-width: 768px) {
    .container {
        padding: 1rem;
    }

    .title-container {
        margin-bottom: 1.5rem;
    }

    .search-row {
        flex-direction: column;
    }

    .doubts-table th, .doubts-table td {
        padding: 0.5rem;
    }
}

@media (max-width: 600px) {
    .btn-weflix.absolute {
        padding: 0.5rem;
    }
    
    .btn-weflix.absolute span {
        display: none;
    }

    .doubts-table-responsive {
        overflow-x: auto;
    }
}
.content.dashboard > .container {
    background-color: white;
    padding: 20px;
    padding-bottom: 35px;
    box-shadow: 0px 6px 10px 0px #dfdfdf;
    min-height: 89vh;
    padding-bottom: 0;
}
select.form-control.filter-form-control {
    width: 60%;
}
.form-group.filter-form-group {
    justify-content: space-around;
    align-items: center;
    margin: 0 !important;
}
.form-group.search-form-group {
    margin: 0 !important;
}
table.table.doubts-table {
    border: none !important;
    padding: 0 !important;
}
button.btn-edit.doubt-btn-edit svg {
    color: #2f2e8b;
}
.form-group.filter-form-group {
    display: flex;
}
.btn-weflix.absolute span.flex {
    font-size: 13px;
}
.btn-weflix.absolute svg {
    color: white;
    font-size: 15px;
}
</style>